import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '../../store/userInfoStore';
import { applicationStore } from '../../store/applicationStore';
import { DEMO_GAME_CURRENCY } from '../../core/constants/gameConstants';
import { useBalance } from '../../hooks/useBalance';

const UserBalance = observer(() => {
  const { userBalance, currencyCode } = userInfoStore;
  const { demoBalance, isDemo } = applicationStore;

  const balance = useBalance(isDemo, demoBalance, userBalance);

  const currency = useMemo(() => {
    return isDemo ? DEMO_GAME_CURRENCY : currencyCode;
  }, [isDemo, currencyCode]);

  return (
    <div className='keno-balance-value'>
      <span className='icon-wallet' />
      <span className='keno-balance-number'>
        {balance} {currency}
      </span>
    </div>
  );
});
export default UserBalance;
